import { c as _c } from "react/compiler-runtime";
import clsx from "classnames";
import React, { useState } from "react";
import { ImagePlaceholder } from "common/components/ImagePlaceholder";
export interface ImageProps {
  /** Image source URL. */
  src: string;
  /** Image alternate text. */
  alt: string;
  /** Caption for the video. */
  caption?: string;
  /** URL to link to when the image is clicked. */
  href?: string;
}
const Figure = t0 => {
  "use memo";

  const $ = _c(16);
  const {
    src,
    alt,
    caption
  } = t0;
  const [imageError, setImageError] = useState(false);
  const showPlaceholder = imageError || !src;
  let t1;
  if ($[0] !== showPlaceholder) {
    t1 = clsx("w-full", {
      hidden: showPlaceholder
    });
    $[0] = showPlaceholder;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setImageError(true);
    t3 = () => setImageError(false);
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== alt || $[5] !== src || $[6] !== t1) {
    t4 = <img className={t1} src={src} alt={alt} loading="lazy" onError={t2} onLoad={t3} />;
    $[4] = alt;
    $[5] = src;
    $[6] = t1;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== showPlaceholder) {
    t5 = showPlaceholder && <ImagePlaceholder />;
    $[8] = showPlaceholder;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== caption) {
    t6 = caption && <figcaption className="mt-1 text-sm text-gray-700">{caption}</figcaption>;
    $[10] = caption;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <figure className="my-4 max-w-(--breakpoint-lg) lg:my-9">{t4}{t5}{t6}</figure>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export const Image = props => {
  "use memo";

  const $ = _c(3);
  const {
    href
  } = props;
  let t0;
  if ($[0] !== href || $[1] !== props) {
    t0 = href ? <a href={href} target="_blank" rel="noreferrer"><Figure {...props} /></a> : <Figure {...props} />;
    $[0] = href;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};